import React, { useState, useEffect, useRef } from 'react'
import { get_today_in_out_time, attendenace_action, get_Today_attendance_time, get_punch_in_time, get_Punch_Time_In_Month, set_clean_attendance, get_HRS_Today, get_weekly_punch_in_time } from "../Redux/Actions/attendance_action"
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate, useLocation } from 'react-router-dom'
import { getPermissions, set_user_info } from "../Redux/Actions/login_actions"
import { useIdleTimer } from 'react-idle-timer';

import jwt_decode from 'jwt-decode';
import Modal from "react-bootstrap/Modal";
import "bootstrap/dist/css/bootstrap.min.css";
import './style.css'
import moment from "moment";
import 'moment-timezone';

import jwt from 'jwt-decode'
import { compareAsc, format } from 'date-fns'
const date = new Date();
let date_formate = format(date, 'yyyy-MM-dd')


function HeaderComp() {

    const dispatch = useDispatch()
    let navigate = useNavigate()
    const gettoken = localStorage.getItem('key');
    const token_data = jwt_decode(gettoken);
    const newToken = JSON.parse(gettoken);
    const storeToken = newToken.value;

    let currentDate = new Date();
    var currenttime = currentDate.getTime()
    if (currenttime > (token_data.exp) * 1000) {
        navigate("/login")
    }
    const [hive_url, setHive_url] = useState('')
    const location = useLocation();
    var string = location.search
    ///////////////////////////
    //User Header Permissions//
    //////////////////////////
    const get_oermission_data = useSelector((state) => state);





    const extract_permissions = get_oermission_data.login_Permission.permissions ? JSON.parse(get_oermission_data.login_Permission.permissions) : '';

    const user_permission = get_oermission_data.login_Permission.permissions;
    const user_info = get_oermission_data.login_Permission.user_data;


    const hr_permission_arr = Array()
    if (user_permission) {
        const hr_permission_arr1 = JSON.parse(user_permission).split(",")
        hr_permission_arr1.map((item, ind) => {
            hr_permission_arr.push(item);
        })
    }
    const country_time_zone = get_oermission_data?.login_Permission?.user_data?.country_time_zone ? get_oermission_data?.login_Permission?.user_data?.country_time_zone : 'Asia/Kolkata';



    // const user_time_as_timezone_test = moment.tz(moment(), 'America/Los_Angeles').format('HH:mm:s') UTC -7
    // const user_time_as_timezone_test = moment.tz(moment(), 'America/Chicago').format('HH:mm:s') UTC -5
    // const user_time_as_timezone_test = moment.tz(moment(), 'Pacific/Honolulu').format('HH:mm:s') UTC -10 
    // const user_time_as_timezone_test = moment.tz(moment(), 'America/Adak').format('HH:mm:s') UTC -9
    // const user_time_as_timezone_test = moment.tz(moment(), 'America/Anchorage').format('HH:mm:s') UTC-8
    // const user_time_as_timezone_test = moment.tz(moment(), 'America/Los_Angeles').format('HH:mm:s') UTC-7
    // const user_time_as_timezone_test = moment.tz(moment(), 'America/Denver').format('HH:mm:s') UTC-6   
    // const user_time_as_timezone_test = moment.tz(moment(), 'Europe/London').format('HH:mm:s') 
    const user_time_as_timezone = moment.tz(moment(), country_time_zone).format('HH:mm:s')
    const user_date_as_timezone = moment.tz(moment(), country_time_zone).format('yyyy-MM-DD')

    //   alert(user_time_as_timezone_test)

    const userFname = user_info?.fname ? user_info?.fname : '';

    const userMname = user_info?.mname ? user_info?.mname : '';
    const userLname = user_info?.lname ? user_info?.lname : '';
    const user_img = user_info?.img ? user_info?.img : user_info?.gender == 1 ? 'm_user.png' : 'f_user.png';

    const [shift, setShift] = useState(get_oermission_data?.login_Permission?.user_data.shift ? get_oermission_data.login_Permission.user_data.shift : 1);




    useEffect(() => {
        const userId = localStorage.getItem('userId');

        dispatch(getPermissions(userId));
        dispatch(set_user_info(userId));
        dispatch(get_Today_attendance_time(localStorage.getItem('userId'), storeToken));
        dispatch(get_punch_in_time(localStorage.getItem('userId'), storeToken));

        const hive_url = '';
        if (window.location.origin == 'http://localhost:3000') {
            setHive_url('http://localhost/connect_hive/login/checkToken')
        }
        if (window.location.origin == 'https://qbsconnectdev.qbslearning.com') {
            setHive_url('https://uathive.qbslearning.com/login/checkToken')
        }
        if (window.location.origin == 'https://qbsconnect.qbslearning.com') {
            setHive_url('https://hive.qbslearning.com/login/checkToken')
        }
        if (window.location.origin == 'https://connectnw2.qbslearning.com') {
            setHive_url('https://hivenw2.qbslearning.com/login/checkToken')
        }

        setMenuactive(false)
        if (window.location.pathname == '/onboarding') {
            setMenuactive(2)
        }
        if (window.location.pathname == '/userreports') {
            setMenuactive(2)
        }
        if (window.location.pathname == '/permission') {
            setMenuactive(2)
        }
        if (window.location.pathname == '/location') {
            setMenuactive(2)
        }
        if (window.location.pathname == '/qbsconnecttalklist') {
            setMenuactive(2)
        }
        if (window.location.pathname == '/holidaylist') {
            setMenuactive(2)
        }
        if (window.location.pathname == '/momentsqbs') {
            setMenuactive(2)
        }
        if (window.location.pathname == '/feed-news') {
            setMenuactive(2)
        }
        if (window.location.pathname == '/resetpassword') {
            setMenuactive(2)
        }
        if (window.location.pathname == '/employeelist') {
            setMenuactive(2)
        }
        if (window.location.pathname == '/quotelist') {
            setMenuactive(2)
        }
        if (window.location.pathname == '/policy') {
            setMenuactive(2)
        }
        if (window.location.pathname == '/skills') {
            setMenuactive(2)
        }
        if (window.location.pathname == '/dashboard') {
            setMenuactive(1)
        }
        if (window.location.pathname == '/updateemail') {
            setMenuactive(7)
        }
        if (window.location.pathname == '/attendance') {
            setMenuactive(4)
        }
        if (window.location.pathname == '/leave') {
            setMenuactive(5)
        }
    }, [window.location.pathname])


    let SERVER_URL = process.env.REACT_APP_API_URL;
    let BASE_URL = process.env.REACT_APP_APP_URL;

    let token = JSON.parse(localStorage.getItem('key'));
    const CheckUserInfo = jwt_decode(token.value);


    const [user, setUser] = useState();
    const [userrole, setUserrole] = useState('');
    const [userdept, setUserdept] = useState('');
    const [role, setRole] = useState();

    const [punchstatus, setPunchstatus] = useState(1);
    const [punchtime, setPunchtime] = useState('');
    const [totalHours, setTotalHours] = useState('');

    const [empId, setEmpId] = useState(token.userId);
    const [login_confirmation, setLogin_confirmation] = useState(false)
    const [menuactive, setMenuactive] = useState('');
    const attend_data = useSelector((state) => state.attendenace?.data?.attendenace_arr);
    const [gettoday, seTgettoday] = useState(moment().date());
    const [timestartmodal, setTimestartmodal] = useState(false)
    const [timestopmodal, setTimestopmodal] = useState(false)
    const [show, setShow] = useState('show')

    const [resermodalmodal, setResermodalmodal] = useState(false)
    const [newpassword, setNewpassword] = useState('');
    const [confirmpassword, setConfirmpassword] = useState('');
    const [oldpassword, setOldpassword] = useState("");
    const [err_oldpass_msg, setErr_oldpass_msg] = useState('');
    const [err_newpass_msg, setErr_newpass_msg] = useState('');
    const [err_confirmpass_msg, setErr_confirmpass_msg] = useState('');
    const [err, setErr] = useState('');

    const [resetpassmsg, setResetpassmsg] = useState('');

    const [attendance_status, setAttendance_status] = useState('')
    const [userId, setUserId] = useState(localStorage.getItem('userId'))
    const timeOutWithLogout = async () => {

        const time_zone = CheckUserInfo.country_time_zone ? CheckUserInfo.country_time_zone : 'Asia/Kolkata';
        const user_time_as_timezone = moment.tz(moment(), time_zone).format('HH:mm:s')
        const user_date_as_timezone = moment.tz(moment(), time_zone).format('yyyy-MM-DD')
        const response = await fetch(SERVER_URL + `api/attendance/time-out`,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    EmpID: CheckUserInfo.userId,
                    LogoutTime: user_time_as_timezone,
                    AttendanceDate: user_date_as_timezone,
                    shift: CheckUserInfo.shift
                }),
            })
            .then(res => res.json())
            .then(data => {
                console.log('Time Out Successfully')
            })
    }

    const logOut = (e) => {

        e.preventDefault();
        clearAttendance()
        // timeOutWithLogout()
        localStorage.removeItem('key');
        localStorage.clear();
        navigate('/login');

    }

    function clearAttendance() {
        dispatch(set_clean_attendance())
    }


    useEffect(() => {
        const gettoken = localStorage.getItem('key');
        const token_data = jwt_decode(gettoken);
        setUser(token_data.name)
        setUserdept(token_data.DepartmentName)
        setUserrole(token_data.RoleName)
        setRole(localStorage.getItem('systemRole'))
    }, [])
    var systemrole = localStorage.getItem('systemRole')


    function getCurrentTime() {
        const date = new Date();
        const showTime = date.getHours()
            + ':' + date.getMinutes()
            + ":" + date.getSeconds();
        return showTime;
    }
    function getCurrentDate() {
        let newDate = new Date()
        let date = ("0" + newDate.getDate()).slice(-2);
        let month = newDate.getMonth() + 1;
        let year = newDate.getFullYear();
        return `${year}-${month < 10 ? `0${month}` : `${month}`}-${date}`
    }
    function calculateHourse(timeIn, timeOut) {
        var startTime = moment(timeIn, 'hh:mm:ss a');
        var endTime = moment(timeOut, 'hh:mm:ss a');
        var totalHours = (endTime.diff(startTime, 'hours'));
        var totalMinutes = endTime.diff(startTime, 'minutes');
        var clearMinutes = totalMinutes % 60;
        return (totalHours + " :" + clearMinutes);
    }
    const getUserTodaysAttendance = async (storeToken) => {
        try {
            dispatch(get_Today_attendance_time(localStorage.getItem('userId'), storeToken));
    
            const getdate = getCurrentDate();
            const empId = localStorage.getItem('userId'); // Ensure empId is defined
            const token = storeToken; // Ensure token is correctly passed
    
            const response = await fetch(`${SERVER_URL}api/attendance/today-attendance-mark`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token}`
                },
                body: JSON.stringify({
                    EmpID: empId,
                    AttendanceDate: getdate,
                    shift_id: CheckUserInfo.shift
                })
            });
    
            const data = await response.json();
            //console.log(data, 'Today Attendance Mark::=============');
    
            if (data.status === true) {
                const resultData = data.data;
                setAttendance_status(data.status);
               
                if (resultData.start_time && resultData.end_time === '00:00:00') {
                    setPunchstatus(2);
                    setPunchtime(resultData.start_time);
                } else {
                    const totalHours = calculateHourse(resultData.start_time, resultData.end_time);
                    setTotalHours(totalHours);
                    setPunchstatus(3);
                }
            } else {
                setPunchstatus(1);
            }
        } catch (error) {
            console.error('Error fetching attendance:', error);
        }
    };
    
    useEffect(() => {
        getUserTodaysAttendance(token.value);        
    }, [])


    const state = {
        emp_id: userId,
        date: date_formate,
        storeToken: storeToken,
    }
    useEffect(() => {
        dispatch(attendenace_action(state))
        dispatch(get_today_in_out_time(userId))
        dispatch(get_Punch_Time_In_Month(userId, storeToken))
    }, [])


    const timestart = () => {
        const currenttime = getCurrentTime()
        const getdate = getCurrentDate()
        const response = fetch(SERVER_URL + `api/attendance/time-in`,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({ EmpID: empId, LoginTime: user_time_as_timezone, AttendanceDate: user_date_as_timezone, shift: CheckUserInfo.shift ? CheckUserInfo.shift : '' }),
            }).then(res => res.json())
            .then(data => {
                setPunchstatus(2)
                getUserTodaysAttendance(token.value)
                dispatch(attendenace_action(state))
                dispatch(get_today_in_out_time(empId))
            })
    }

    const timestop = () => {
        const currenttime = getCurrentTime()
        const getdate = getCurrentDate()
        // alert(getdate)
        // alert(user_date_as_timezone)
        // return false
        const time_zone = CheckUserInfo.country_time_zone ? CheckUserInfo.country_time_zone : 'Asia/Kolkata';
        const user_time_as_timezone = moment.tz(moment(), time_zone).format('HH:mm:s')
        const user_date_as_timezone = moment.tz(moment(), time_zone).format('yyyy-MM-DD')
        const response = fetch(SERVER_URL + `api/attendance/time-out`,
            {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({ EmpID: empId, LogoutTime: user_time_as_timezone, AttendanceDate: user_date_as_timezone, shift: CheckUserInfo.shift ? CheckUserInfo.shift : '' }),
            }).then(res => res.json())
            .then(data => {
                setPunchstatus(3)
                getUserTodaysAttendance(storeToken)
                dispatch(attendenace_action(state))
                dispatch(get_HRS_Today(state))
                dispatch(get_weekly_punch_in_time(empId, token))
                dispatch(get_Punch_Time_In_Month(empId, storeToken))
                dispatch(get_today_in_out_time(empId))
            })
    }

    const loginHourse = () => {
        calculateHourse(punchtime, getCurrentTime())
    }



    const handlePunchIn = () => {
        timestart()

    }
    const handlePunchOut = () => {
        setTimestopmodal(true)

    }
    const handleTimeOut = () => {
        timestop()
        setTimestopmodal(false)
    }
    const handleTimeNotnow = () => {
        setTimestopmodal(false)
    }
    const handleResetPassModal = () => {
        setResermodalmodal(true)
    }
    const handleClose = (e) => {
        setResermodalmodal(false);
        setOldpassword('')
        setNewpassword('')
        setConfirmpassword('')
        setResetpassmsg('');
        setErr_oldpass_msg('')
        setErr_newpass_msg('')
        setErr_confirmpass_msg('')
    };
    const handleResetPassword = () => {
        setErr_oldpass_msg('')
        setErr_newpass_msg('')
        setErr_confirmpass_msg('')
        if (oldpassword == '' || oldpassword.length < 5) {
            setErr_oldpass_msg('this Field is required!')
            setErr('red')
        } else if (newpassword == '' || newpassword.length < 5) {
            setErr_newpass_msg('this Field is required!')
            setErr('red')
        } else {

            if (newpassword != confirmpassword) {
                setErr_confirmpass_msg('new and confirmation password not match!')
                setErr('red')
            } else {
                let token = JSON.parse(localStorage.getItem('key'));
                var token_decod = jwt(token.value)
                handleOldPasswordChange(token_decod.email)
            }
        }
    }

    const handleOldPasswordChange = async (email) => {
        const response = await fetch(SERVER_URL + `api/login/validate-old-password`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ email: email, oldPassword: oldpassword }),
        });
        const data = await response.json();
        if (data.status == true) {
            const response = await fetch(SERVER_URL + `api/login/change-new-password`, {
                method: "PUT",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    email: email,
                    password: newpassword
                }),
            });
            if (response.ok == true) {
                setResetpassmsg(' password has been changed successfully')
                setErr('green')
                setTimeout(function () {
                    handleClose()
                }, 1000);
            } else {
                setResetpassmsg(' Something wend wrong!')
                setErr('red')
            }

        } else {
            setErr_oldpass_msg('Is not valid')
        }
    }
    const [supportmodal, setSupportmodal] = useState(false);
    const handleSupport = () => {
        setSupportmodal(true)
    }
    const closeSupport = () => {
        setSupportmodal(false)
    }


    const [suggestionmodal, setSuggestionmodal] = useState(false);
    const [suggestion_type, setSuggestion_type] = useState('');
    const [suggestion_title, setSuggestion_title] = useState('');
    const [suggestion_message, setSuggestion_message] = useState('');
    const [errmsg_sug_type, setErrmsg_sug_type] = useState('');
    const [errmsg_sug_title, setErrmsg_sug_title] = useState('');
    const [errmsg_sug_message, setErrmsg_sug_message] = useState('');
    const [color, setColor] = useState('');
    const [errmsg, setErrmsg] = useState('');
    const [sucmsg, setSucmsg] = useState('');
    const [buttonstatus, setbuttonstatus] = useState(true);

    const feedback_suggestion = () => {
        setSuggestionmodal(true)
    }
    const suggestion_close = () => {
        setSuggestionmodal(false)
        setErrmsg_sug_type('')
        setErrmsg_sug_title('');
        setErrmsg_sug_message('')
        setSuggestion_type('');
        setSuggestion_title('')
        setSuggestion_message('')
    }
    const suggestion_typeRef = useRef();
    const suggestion_titleRef = useRef();
    const suggestion_messageRef = useRef();

    const suggestion_save = () => {
        setErrmsg_sug_type('')
        setErrmsg_sug_title('');
        setErrmsg_sug_message('')
        if (suggestion_type == '') {
            setErr('red');
            setErrmsg_sug_type('This field is require')
            suggestion_typeRef.current.focus();
            return false
        } else if (suggestion_title == '') {
            setErr('red');
            setErrmsg_sug_title('This field is require')
            suggestion_titleRef.current.focus();
        } else if (suggestion_message == '') {
            setErr('red');
            setErrmsg_sug_message('This field is require')
            suggestion_messageRef.current.focus();
        } else {
            setbuttonstatus(true)
            const userId = localStorage.getItem('userId');
            const response = fetch(SERVER_URL + `api/employee/create-feedback-suggestion`,
                {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'authorization': `bearer ${token.value}`
                    },
                    body: JSON.stringify({
                        typeOfFeedback: suggestion_type,
                        subjectName: suggestion_title,
                        message: suggestion_message,
                        requestedBy: userId
                    }),
                }).then(res => res.json())
                .then(data => {
                    if (data.status === true) {
                        const popupMsg = suggestion_type == 1 ? 'Portal Suggestion Add Successfully' : 'QBS Connect Talk Add Successfully'
                        setSucmsg(popupMsg)
                        setColor('green')
                        setTimeout(function () {
                            suggestion_close()
                        }, 1000);
                    } else {
                        setSucmsg('Error! Something went wrong')
                        setbuttonstatus(true)
                        setColor('red')
                    }
                })



        }

        return false;
    }


    const [picture, setPicture] = useState(null);
    const HandleProfileImg = async (e) => {
        if (e.target.files[0]) {
            setPicture(e.target.files[0]);
            const formdata = new FormData();
            formdata.append('user_id', userId);
            formdata.append('userImage', e.target.files[0]);
            upload_User_Image(formdata)
        }

    }
    function upload_User_Image(formdata) {
        const response = fetch(SERVER_URL + `api/employee/user-image-update`,
            {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: formdata,
            }).then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    dispatch(set_user_info(userId))
                }
            })
    }

    const [department, setDepartment] = useState('');
    const [subject, setSubject] = useState('');
    const [msg, setMsg] = useState('');

    const HandleSendMail = () => {
        const response = fetch(SERVER_URL + `api/helpsupprt/support`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'authorization': `bearer ${token.value}`
            },
            body: JSON.stringify({
                department: department,
                subject: subject,
                msg: msg,
                requestedBy: userId
            }),
        }).then(res => res.json()).then(data => {
            if (data.status == true) {

            }
        })
    }
    const [passtype, setPasstype] = useState('password');
    const handleShowPassword = () => {
        if (passtype == 'text') {
            setPasstype('password');
        } else {
            setPasstype('text')
        }
    }
    const [passtype_new, setPasstype_new] = useState('password');
    const handleShowPasswordNew = () => {
        if (passtype_new == 'text') {
            setPasstype_new('password');
        } else {
            setPasstype_new('text')
        }
    }

    return (
        <header className="dash_header mb-5">
            <Modal show={suggestionmodal} size="md" id="confirm_login">
                <div className="modal-body">
                    <button type="button" onClick={suggestion_close} className="float-end btn_close" data-bs-dismiss="modal" aria-label="Close">
                        <i className="icon icon-cross"></i>
                    </button>
                    <div className="dash_white_box_ttl text-center">Feedback & Suggestion</div>
                    <form>
                        <div className="mb-2">
                            <label className="col-form-label">Type of Suggestion</label>
                            <span style={{ color: err }}>{errmsg_sug_type}</span>
                            <select ref={suggestion_typeRef} value={suggestion_type} onChange={e => { setSuggestion_type(e.target.value) }} className="form-select">
                                <option value=''>Select Suggestion</option>
                                <option value='1'>Portal Suggestion</option>
                                <option value='2'>QBS Connect Talk</option>
                                <option value='3'>Client Feedback</option>
                            </select>
                        </div>
                        <div className="mb-2">
                            <label className="col-form-label">Subject</label>
                            <span style={{ color: err }}>{errmsg_sug_title}</span>
                            <input ref={suggestion_titleRef} onChange={e => { setSuggestion_title(e.target.value) }} value={suggestion_title} type="text" className="form-control" placeholder="" name="" />
                        </div>
                        <div className="mb-3">
                            <label className="col-form-label">Message</label>
                            <span style={{ color: err }}>{errmsg_sug_message}</span>
                            <textarea ref={suggestion_messageRef} onChange={e => { setSuggestion_message(e.target.value) }} value={suggestion_message} className="form-control">{suggestion_message}</textarea>
                        </div>
                    </form>
                    <div className="modalfooter">
                        <span style={{ color: color }}>{sucmsg}</span>
                        <button type="button" onClick={suggestion_close} className="btn_6 float-end ml10" data-bs-dismiss="modal">Cancel</button>
                        <button type="button" onClick={suggestion_save} className="btn_5 float-end ">Send</button>
                    </div>
                </div>

            </Modal>
            <Modal show={supportmodal} size="md" id="confirm_login">
                <div className="modal-body">
                    <button type="button" className="float-end btn_close" data-bs-dismiss="modal" aria-label="Close">
                        <i className="icon icon-cross" onClick={closeSupport}></i>
                    </button>
                    <div className="dash_white_box_ttl text-center">Help & Support</div>
                    <p>Browse Knowledge articles, submit a question or call support, and check the status of previously submitted questions.</p>
                    <h4>My Service Team</h4>
                    <form>
                        <div className="mb-2">
                            <label className="col-form-label">To</label>
                            <select value={department} onChange={e => setDepartment(e.target.value)} className="form-select">
                                <option value=''>Admin</option>
                                <option value='1'>Information Technology</option>
                                <option value='2'>Finance</option>
                                <option value='3'>Human Resource (HR)</option>
                            </select>
                        </div>
                        <div className="mb-2">
                            <label className="col-form-label">Subject</label>
                            <input value={subject} onChange={e => setSubject(e.target.value)} type="text" className="form-control" placeholder="Enter subject" />
                        </div>
                        <div className="mb-3">
                            <label className="col-form-label">Message</label>
                            <textarea onChange={e => setMsg(e.target.value)} className="form-control">{msg}</textarea>
                        </div>
                    </form>
                    <div className="modalfooter">
                        <button type="button" className="btn_6 float-end ml10" onClick={closeSupport}>Cancel</button>
                        <button type="button" onClick={HandleSendMail} className="btn_5 float-end ">Send</button>
                    </div>
                </div>
            </Modal>
            <Modal show={resermodalmodal} size="md" id="confirm_login">
                <div className="modal-body p20">
                    <button type="button" className="float-end btn_close" onClick={handleClose}>
                        <i className="icon icon-cross" />
                    </button>
                    <div className="change_img_blk">
                        <img src="/assets/images/changepass_img.png" alt="" />
                    </div>
                    <div className="dash_white_box_ttl mb05 text-center" id="exampleModalLabel">Change Password</div>
                    <p className="mb10">Please enter your new password. Choose a password which is easy to remember but difficult for others to guess</p>

                    <div className="mb-2">
                        <label className="col-form-label">Old Password: <span className="error_mgs">*</span><span style={{ color: err ? err : '' }}>{err_oldpass_msg}</span></label>
                        <div className="form-input">
                            <input type={passtype ? passtype : 'password'} autoComplete='new-password' name='new-password' className="form-control" value={oldpassword} onChange={(e) => { setOldpassword(e.target.value) }} />
                            <span className="icon_wrp">
                                <i className={`${passtype == "text" ? 'icon icon-eye-crossed' : 'icon icon-eye'}`} onClick={handleShowPassword}></i>
                            </span>
                        </div>
                    </div>
                    <div className="mb-2">
                        <label className="col-form-label">New Password: <span className="error_mgs">*</span><span style={{ color: err ? err : '' }}>{err_newpass_msg}</span></label>
                        <div className="form-input">
                            <input type={passtype_new ? passtype_new : 'password'} className="form-control" placeholder="" value={newpassword} onChange={(event) => setNewpassword(event.target.value)} />
                            <span className="icon_wrp">
                                <i className={`${passtype_new == "text" ? 'icon icon-eye-crossed' : 'icon icon-eye'}`} onClick={handleShowPasswordNew}></i>
                            </span>
                        </div>
                    </div>
                    <div className="mb-3">
                        <label className="col-form-label">Confirm  Password: <span className="error_mgs">*</span><span style={{ color: err ? err : '' }}>{err_confirmpass_msg}</span></label>
                        <input type="password" className="form-control" placeholder="" value={confirmpassword} onChange={(event) => setConfirmpassword(event.target.value)} />

                    </div>
                    <div className="modalfooter">
                        <span style={{ color: err ? err : '' }}>{resetpassmsg}</span>
                        <button type="button" className="btn_6 float-end ml10" onClick={handleClose}>Cancel</button>
                        <button type="submit" onClick={handleResetPassword} className="btn_5 float-end " >Save</button>
                    </div>
                </div>
            </Modal>



            <Modal show={timestopmodal} size="sm" id="confirm_login">
                <div className="modal-content modalcontent1">
                    <div className="modal-body">
                        <div className="swal2-icon swal2-warning swal2-icon-show" style={{ display: "flex" }}>
                            <div className="swal2-icon-content">!</div>
                        </div>
                        <h4>Are you sure?</h4>
                        <p>Do you want to Stop Time?</p>
                        <button type="button" onClick={handleTimeOut} className="btn_9 mr05" data-bs-dismiss="modal">Yes</button>
                        <button type="button" onClick={handleTimeNotnow} className="btn_6" data-bs-dismiss="modal">No</button>
                    </div>
                </div>
            </Modal>
            <div className='relative'>
                <div className="time_in_out_wrp">
                    <div className="text-end notification_blk"> {
                        (function () {
                            if ((attendance_status === 0 && attendance_status !== '') || punchtime == '00:00:00') {
                                return <span className='btn_1'>On Leave</span>
                            } else {
                                return <>
                                    {punchstatus == 2 ?
                                        <div className='mark_att_wrp'>
                                            <span className='mark_att'>Login Time:</span>
                                            <span className='mark_time'>{punchtime ? punchtime.slice(0, 5) : ''}</span>
                                        </div>
                                        : ''}
                                    {/* {punchstatus === 1 ?
                                     <button onClick={handlePunchIn} className="btn_1">Start Time </button> 
                                  
                                    : punchstatus == 2 ?
                                        <div>
                                            <span className='time_txt'>Started At: {punchtime ? punchtime.slice(0, 5) : ''} </span>
                                            <button onClick={handlePunchOut} className="btn_2">Stop Time</button>
                                        </div> : 
                                        punchstatus === 3 ? 
                                        <button onClick={handlePunchIn} className="btn_1">Start Time </button> 
                                        : ''
                                    } */}
                                </>
                            }
                        }())
                    }
                        {/* {(attendance_status !== 0 && attendance_status === '') && <>
                            {punchstatus == 1 ? <button onClick={handlePunchIn} className="btn_1">Start Time</button> : punchstatus == 2 ?
                                <div>
                                    <span className='time_txt'>Started At: {punchtime ? punchtime.slice(0, 5) : ''} </span>
                                    <button onClick={handlePunchOut} className="btn_2">Stop Time</button>
                                </div> : punchstatus == 3 ? totalHours ? <span className='time_txt'>Total Time:{totalHours} HRS </span> : '' : ''
                            }
                        </>} */}

                    </div>
                    <div className="dropdown user_wrp text-end">
                        <a href="#" className="dropdown-toggle relative" id="notification" data-bs-toggle="dropdown" aria-expanded="false">
                            {/* <span className="noti_numbering">10</span> */}
                            {/* <span className="noti_numbering"></span> */}
                            <div className="bell" id="bell-1">
                                <div className="anchor material-icons layer-1">notifications_active</div>
                                <div className="anchor material-icons layer-2">notifications</div>
                                <div className="anchor material-icons layer-3">notifications</div>
                            </div>
                        </a>
                        <ul className="dropdown-menu notification-list shadow" aria-labelledby="notification" >
                            <li className="notification_header">Notification </li>
                            <li className="notification_empty">
                                <img alt="" src="assets/images/empty.jpg" />
                                <h3>No Notification Yet</h3>
                                <p>You have no notification right Now.</p>
                            </li>
                            {/*<li className="notification-message">
                                 <a href="#">
                                    <div className="notify_list">
                                        <i className="avatar_icon icon icon-check"></i>
                                        <div className="noti-details-content">
                                            <p className="noti-details">Please check your mail</p>
                                            <p className="noti-time"><i className="icon icon-clock mr03"></i>4 mins ago</p>
                                        </div>
                                    </div>
                                </a>
                                <a href="#">
                                    <div className="notify_list">
                                        <span className="avatar_img">
                                            <img alt="" src="assets/images/m_user.png" />
                                        </span>
                                        <div className="noti-details-content">
                                            <p className="noti-details">New Employee Added..</p>
                                            <p className="noti-time"><i className="icon icon-clock mr03"></i>6 mins ago</p>
                                        </div>
                                    </div>
                                </a>
                                <a href="#">
                                    <div className="notify_list">
                                        <i className="avatar_icon icon icon-check"></i>
                                        <div className="noti-details-content">
                                            <p className="noti-details">Your leave is approved!! </p>
                                            <p className="noti-time"><i className="icon icon-clock mr03"></i>8 mins ago</p>
                                        </div>
                                    </div>
                                </a>
                                <a href="#">
                                    <div className="notify_list">
                                        <span className="avatar_img">
                                            <img alt="" src="assets/images/m_user.png" />
                                        </span>
                                        <div className="noti-details-content">
                                            <p className="noti-details">New Employee Added..</p>
                                            <p className="noti-time"><i className="icon icon-clock mr03"></i>6 mins ago</p>
                                        </div>
                                    </div>
                                </a>
                                <a href="#">
                                    <div className="notify_list">
                                        <i className="avatar_icon icon icon-check"></i>
                                        <div className="noti-details-content">
                                            <p className="noti-details">Your leave is approved!! </p>
                                            <p className="noti-time"><i className="icon icon-clock mr03"></i>8 mins ago</p>
                                        </div>
                                    </div>
                                </a> 
                            </li>
                            {/* <li className="notification_footer">
                                <a href="notification.html">View all Notifications</a>
                            </li> */}
                        </ul>
                    </div>

                    <div className="dropdown user_wrp text-end">
                        <Link to="#" className="dropdown-toggle" id="dropdownUser2" data-bs-toggle="dropdown" aria-expanded="false">
                            <div className="user_blk">
                                <span className="username">
                                    {
                                        (userFname + ' ' + userMname + ' ' + userLname).toUpperCase().match(/\b(\w)/g)
                                    }
                                </span>
                            </div>
                        </Link>
                        <ul className="dropdown-menu user_dropdown shadow" aria-labelledby="dropdownUser2" >
                            <li className="user_pic">
                                <div className="pro_img profile_upload_wrp">
                                    <img src={`${SERVER_URL + "userimages/" + user_img}`} alt="" />
                                    <div className="buttonwrap">
                                        <label className="button_upload" htmlFor="upload"><i className="fa fa-camera"></i></label>
                                        <input id="upload" type="file" onChange={HandleProfileImg} />
                                    </div>
                                </div>
                                <span className="user_name">{userFname + ' ' + userMname + ' ' + userLname}</span>
                                <span className="user_department">{user_info?.dept_name ? user_info.dept_name : ""}</span>
                                <span className="user_designation"> {user_info?.role_name ? ', ' + user_info.role_name : ""}</span>
                            </li>
                            <li><Link className="dropdown-item" to="/profile">Profile </Link></li>
                            {/* <li><Link className="dropdown-item" to="/updateprofile">Update </Link></li> */}
                            <li><button className="dropdown-item" onClick={feedback_suggestion}>Feedback & Suggestion</button></li>
                            <li><button onClick={handleSupport} className="dropdown-item">Help & Support</button></li>
                            <li><button type="submit" className="dropdown-item" onClick={handleResetPassModal}>Change Password</button></li>
                            <li><button className="dropdown-item" onClick={logOut}>Logout</button></li>
                        </ul>
                    </div>
                </div>
                <nav className="navbar navbar-expand-lg">
                    <button className="navbar-toggler navbar_toggle" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="navbar-brand d-block d-lg-none relative">
                        <Link to="/dashboard"><img src="/assets/images/mob_logo.png" alt="logo" className="dash_company_logo" /></Link>
                        <form method="post" className="hive_logo_wrp" action={hive_url} target='_blank'>
                            <input type='hidden' name="token" value={storeToken} />
                            <button type='submit' >
                                <img className="hive_logo" src="/assets/images/hive.png" />
                            </button>
                        </form>
                    </div>

                    <div className="navbar-brand d-none d-lg-block dash_navbar_brand relative">
                        <Link to="/dashboard"><img src="/assets/images/logo.png" alt="logo" className="dash_company_logo" /></Link>
                        <form method="post" className="hive_logo_wrp" action={hive_url} target='_blank'>
                            <input type='hidden' name="token" value={storeToken} />
                            <button type='submit' >
                                <img className="hive_logo" src="/assets/images/hive.png" />
                            </button>
                        </form>
                    </div>

                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        <ul className="navbar-nav">

                            {
                                hr_permission_arr?.includes('1') && <li className="nav-item">
                                    <Link to='/dashboard' className={`nav-link ${menuactive == 1 ? 'active' : ''}`} aria-current="page" >Home<span className="line"></span></Link>
                                </li>
                            }

                            {
                                hr_permission_arr?.includes('2') && <li className='nav-item'>
                                    <Link className={`nav-link ${menuactive == 2 ? 'active' : ''}`} to="/policy">HR<span className="line"></span></Link>
                                </li>
                            }

                            {
                                hr_permission_arr?.includes('3') && <li className='nav-item'>
                                    <Link className={`nav-link ${menuactive == 7 ? 'active' : ''}`} to="/updateemail">IT<span className="line"></span></Link>
                                </li>
                            }


                            <li className="nav-item">
                            </li>
                            {
                                hr_permission_arr?.includes('4') && <li className="nav-item">
                                    <Link className={`nav-link ${menuactive == 4 ? 'active' : ''}`} to="/attendance">Attendance<span className="line"></span></Link>
                                </li>
                            }


                            {
                                hr_permission_arr?.includes('5') && <li className="nav-item">
                                    <Link className={`nav-link ${menuactive == 5 ? 'active' : ''}`} to="/leave">Leave<span className="line"></span></Link>
                                </li>
                            }


                            <li className="nav-item">
                                {/* <Link onClick={e => { setMenuactive(6) }} className={`nav-link ${menuactive == 6 ? 'active' : ''}`} to="#">Reports<span className="line"></span></Link> */}
                            </li>
                        </ul>

                    </div>

                </nav>
            </div>

        </header>
    )
}

export default HeaderComp
